import { createApp, h } from 'vue';

import ModellSelectorAccessories from './components/modell-selector-accessories';
import i18n from './modellregister-i18n';

mcWeb.ModelRegisterAccessories = new function () {
    'use strict';

    this.initializeModelRegisterAccessoriesInstance = function (webPubElmementId, isPublishMode, hideClass) {
        console.log("Initializing modelregister-accessories for webpubid=" + webPubElmementId);
        var elm = document.querySelector('#model-selector-accessories-form-' + webPubElmementId);
        if (!elm) {
            console.log("Failed to init modelreg-accessories with elmid:" + webPubElmementId);
            return;
        }
        console.log("the DOM'elements data-accessories-pageurl: " + elm.getAttribute("data-accessories-pageurl"));
        var accessoriesPageUrl = elm.getAttribute("data-accessories-pageurl");
        var modellRegisterAccessories = createApp({
            i18n,
            components: {
                'modell-selector-accessories': ModellSelectorAccessories
            },
            data() {
                return {
                    accessoriesPageUrl: accessoriesPageUrl,
                    postedData: null,
                    isPublishMode: isPublishMode,
                    hideClass: hideClass
                }
            },
            methods: {

            },
            created: function () {
            },
            beforeDestroy: function () {
            }
            , render: () => h(ModellSelectorAccessories)
        });
        modellRegisterAccessories.use(i18n);
        modellRegisterAccessories.mount(elm);                
    };
    
};






